import { useEffect, useState } from 'react';

/** The current time, ticking on each second -- what a countdown redraws from. */
export function useSecondClock(): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    let timer = 0;
    const tick = () => {
      setNow(Date.now());
      timer = window.setTimeout(tick, 1000 - (Date.now() % 1000) + 5);
    };
    timer = window.setTimeout(tick, 1000 - (Date.now() % 1000) + 5);
    return () => {
      window.clearTimeout(timer);
    };
  }, []);
  return now;
}
